export default defineNuxtPlugin({
  name: 'geo',
  parallel: true,
  async setup() {
    // Resolve the visitor's country into the `client_country` cookie at boot, so
    // region-dependent UI has an answer before its first render. See
    // `composables/useClientCountry.ts` for why the cookie exists at all; the
    // deposit modal re-runs `refresh()` on open to catch a mid-session VPN switch.
    await useClientCountry().refresh()
  },
})
